/* ==========================================================================
   Prism & Pocket — theme.js  (vanilla, no dependencies)
   ========================================================================== */
(function () {
  'use strict';

  const routes = window.routes || {};
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from((ctx || document).querySelectorAll(sel));
  const money = (cents) => {
    try { return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  };

  /* ---- Toast ---------------------------------------------------------- */
  let toastEl;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(() => toastEl.classList.remove('is-visible'), 2600);
  }

  /* ---- Focus trap / drawer controller --------------------------------- */
  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  let activeDrawer = null;
  let lastFocused = null;

  function openDrawer(drawer, opener) {
    if (!drawer) return;
    lastFocused = opener || document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    activeDrawer = drawer;
    const focusTarget = drawer.querySelector('[data-autofocus]') || drawer.querySelector(FOCUSABLE);
    if (focusTarget) setTimeout(() => focusTarget.focus(), 60);
  }
  function closeDrawer(drawer) {
    drawer = drawer || activeDrawer;
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    activeDrawer = null;
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }
  function trapFocus(e) {
    if (!activeDrawer || e.key !== 'Tab') return;
    const items = $$(FOCUSABLE, activeDrawer).filter(el => el.offsetParent !== null);
    if (!items.length) return;
    const first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && activeDrawer) closeDrawer();
    trapFocus(e);
  });
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer($('#' + opener.getAttribute('data-drawer-open')), opener); }
    if (e.target.closest('[data-drawer-close]') || e.target.classList.contains('drawer__overlay')) {
      e.preventDefault(); closeDrawer(e.target.closest('.drawer'));
    }
  });

  /* ---- Cart ----------------------------------------------------------- */
  const Cart = {
    async add(items, opener) {
      const btn = opener;
      if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
      try {
        const res = await fetch(routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items, sections: ['cart-drawer'], sections_url: window.location.pathname })
        });
        const data = await res.json();
        if (!res.ok) { toast(data.description || data.message || window.cartStrings?.error); return null; }
        await this.refresh(data);
        const drawer = $('#CartDrawer');
        if (drawer) openDrawer(drawer, opener); else window.location = routes.cart_url;
        return data;
      } catch (err) { toast(window.cartStrings?.error || 'Error'); return null; }
      finally { if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); } }
    },
    async change(line, quantity) {
      const res = await fetch(routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line, quantity, sections: ['cart-drawer'], sections_url: window.location.pathname })
      });
      const data = await res.json();
      await this.refresh(data);
      return data;
    },
    async refresh(data) {
      // Update drawer markup if sections returned
      if (data && data.sections && data.sections['cart-drawer']) {
        const html = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
        const fresh = html.querySelector('[data-cart-contents]');
        const target = $('[data-cart-contents]');
        if (fresh && target) target.innerHTML = fresh.innerHTML;
      } else {
        // fetch fresh cart state
        try {
          const r = await fetch(routes.cart_url + '?section_id=cart-drawer');
          const t = await r.text();
          const doc = new DOMParser().parseFromString(t, 'text/html');
          const fresh = doc.querySelector('[data-cart-contents]');
          const target = $('[data-cart-contents]');
          if (fresh && target) target.innerHTML = fresh.innerHTML;
        } catch (e) {}
      }
      // Update count bubbles. /cart/add.js does not return item_count, so fall back to /cart.js
      let count = (data && typeof data.item_count === 'number') ? data.item_count : null;
      if (count === null) {
        try { const c = await (await fetch(routes.cart_url + '.js')).json(); count = c.item_count; } catch (e) {}
      }
      if (count !== null) $$('[data-cart-count]').forEach(el => { el.textContent = count; el.setAttribute('data-count', count); });
      cartExtras();
    }
  };
  window.PrismCart = Cart;

  /* ---- Cart extras: free-gift enforcement + dispatch countdown -------- */
  let giftBusy = false;
  function cartExtras() {
    const st = document.querySelector('[data-gift-state]');
    if (st && st.getAttribute('data-eligible') === 'false' && !giftBusy) {
      const line = parseInt(st.getAttribute('data-gift-line'), 10);
      if (line > 0) { giftBusy = true; Cart.change(line, 0).finally(() => { giftBusy = false; }); }
    }
  }
  function tickDispatch() {
    document.querySelectorAll('[data-dispatch-remaining]').forEach((el) => {
      if (el.__done) return;
      if (el.__end == null) {
        el.__end = Date.now() + (parseInt(el.getAttribute('data-dispatch-remaining'), 10) || 0) * 1000;
      }
      let ms = el.__end - Date.now();
      if (ms <= 0) {
        el.__done = true;
        el.classList.add('dispatch--muted');
        const after = el.getAttribute('data-dispatch-after') || '';
        const span = el.querySelector('span');
        if (span) span.textContent = after;
        return;
      }
      const s = Math.floor(ms / 1000);
      const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
      const clock = el.querySelector('[data-dispatch-clock]');
      if (clock) clock.textContent = (h > 0 ? h + 'h ' : '') + m + 'm ' + sec + 's';
    });
  }
  setInterval(tickDispatch, 1000);
  tickDispatch();

  // Add-to-cart forms (product page + quick shop) and quick-add buttons
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-cart-form]');
    if (!form) return;
    e.preventDefault();
    const fd = new FormData(form);
    const id = fd.get('id');
    const qty = parseInt(fd.get('quantity') || '1', 10);
    if (!id) return;
    Cart.add([{ id: Number(id), quantity: qty }], form.querySelector('[type="submit"]'));
  });

  document.addEventListener('click', (e) => {
    const qa = e.target.closest('[data-quick-add]');
    if (qa) {
      e.preventDefault();
      const variantId = qa.getAttribute('data-variant-id');
      Cart.add([{ id: Number(variantId), quantity: 1 }], qa);
    }
    // free gift add (with line item property so we can identify & enforce it)
    const ga = e.target.closest('[data-gift-add]');
    if (ga) {
      e.preventDefault();
      Cart.add([{ id: Number(ga.getAttribute('data-variant-id')), quantity: 1, properties: { _free_gift: 'true' } }], ga);
    }
    // qty steppers
    const step = e.target.closest('[data-qty-step]');
    if (step) {
      const wrap = step.closest('.qty');
      const input = wrap.querySelector('input');
      const dir = parseInt(step.getAttribute('data-qty-step'), 10);
      let val = Math.max(parseInt(input.min || '0', 10), (parseInt(input.value, 10) || 1) + dir);
      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    // cart line remove
    const rm = e.target.closest('[data-cart-remove]');
    if (rm) { e.preventDefault(); Cart.change(parseInt(rm.getAttribute('data-cart-remove'), 10), 0); }
  });

  /* ---- Product card click animation ---------------------------------- */
  function sparkleBurst(card, count) {
    const host = card.querySelector('.product-card__media') || card;
    for (let i = 0; i < count; i++) {
      const s = document.createElement('span');
      s.className = 'sparkle-burst';
      s.style.left = (22 + Math.random() * 56) + '%';
      s.style.top = (22 + Math.random() * 56) + '%';
      s.style.setProperty('--tx', (Math.random() * 44 - 22).toFixed(0) + 'px');
      s.style.setProperty('--ty', (-14 - Math.random() * 34).toFixed(0) + 'px');
      s.style.animationDelay = (Math.random() * 0.12).toFixed(2) + 's';
      s.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l1.8 6.2L20 10l-6.2 1.8L12 18l-1.8-6.2L4 10l6.2-1.8z"/></svg>';
      host.appendChild(s);
      setTimeout(() => s.remove(), 760);
    }
  }
  document.addEventListener('click', (e) => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const link = e.target.closest('a[href]');
    if (!link || link.target === '_blank') return;
    const card = link.closest('[data-product-card]');
    if (!card) return;
    const fx = card.getAttribute('data-fx');
    if (!fx || fx === 'off' || card.classList.contains('card-fx-active')) return;
    // honour reduced-motion: skip the effect, navigate normally
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    e.preventDefault();
    const href = link.href;
    card.classList.add('card-fx-active');
    if (fx === 'sparkle') sparkleBurst(card, 7);
    const wait = fx === 'sparkle' ? 560 : (fx === 'holo' ? 480 : 340);
    setTimeout(() => { window.location.href = href; }, wait);
  });

  // cart line qty change
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-cart-line]');
    if (!input) return;
    const line = parseInt(input.getAttribute('data-cart-line'), 10);
    const q = Math.max(0, parseInt(input.value, 10) || 0);
    Cart.change(line, q);
  });

  /* ---- Quick shop modal ---------------------------------------------- */
  document.addEventListener('click', async (e) => {
    const trigger = e.target.closest('[data-quick-shop]');
    if (!trigger) return;
    e.preventDefault();
    const handle = trigger.getAttribute('data-quick-shop');
    const host = $('#QuickShopHost');
    trigger.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(`/products/${handle}?section_id=quick-shop`);
      const text = await res.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const content = doc.querySelector('[data-quick-shop-content]');
      if (!content) { window.location = `/products/${handle}`; return; }
      host.innerHTML = `<div class="drawer quick-shop-drawer" id="QuickShopDrawer" aria-hidden="true" role="dialog" aria-modal="true" aria-label="Quick shop">
        <div class="drawer__overlay" data-drawer-close></div>
        <div class="drawer__panel">
          <div class="drawer__header"><span class="drawer__title">Quick shop</span>
          <button class="drawer__close" data-drawer-close aria-label="Close">&times;</button></div>
          <div class="drawer__body">${content.innerHTML}</div>
        </div></div>`;
      openDrawer($('#QuickShopDrawer'), trigger);
      initVariantPickers(host);
    } catch (err) { window.location = `/products/${handle}`; }
    finally { trigger.removeAttribute('aria-busy'); }
  });

  /* ---- Variant picker (product page + quick shop) -------------------- */
  function initVariantPickers(ctx = document) {
    $$('[data-variant-picker]', ctx).forEach((picker) => {
      if (picker._init) return; picker._init = true;
      let variants = [];
      try { variants = JSON.parse(picker.querySelector('[data-variants-json]').textContent); } catch (e) {}
      const form = picker.closest('form') || picker;
      const update = (isUserChange = false) => {
        const selected = $$('select[data-option], input[data-option]:checked', picker).map(el => el.value);
        // Guard: if no variants parsed (single-variant product), leave server-rendered state
        if (!variants.length) return;
        const match = variants.find(v => v.options.every((o, i) => o === selected[i]));
        const idInput = form.querySelector('[name="id"]');
        const priceEl = picker.querySelector('[data-variant-price]');
        const submit = form.querySelector('[type="submit"]');
        // disable unavailable option pills
        $$('input[data-option]', picker).forEach(inp => {
          const idx = parseInt(inp.getAttribute('data-option-index'), 10);
          const test = selected.slice(); test[idx] = inp.value;
          const exists = variants.some(v => v.available && v.options.every((o, i) => o === test[i]));
          inp.disabled = !exists;
        });
        if (match) {
          if (idInput) idInput.value = match.id;
          // Switch gallery to variant's featured image
          if (match.featured_media_id) {
            const gal = document.querySelector('[data-gallery]');
            if (gal && gal._showMedia) gal._showMedia(String(match.featured_media_id));
          }
          if (priceEl) priceEl.innerHTML = match.compare_at_price && match.compare_at_price > match.price
            ? `<span class="price__current">${money(match.price)}</span><span class="price__compare">${money(match.compare_at_price)}</span>`
            : `<span class="price__current">${money(match.price)}</span>`;
          if (submit) {
            submit.disabled = !match.available;
            submit.textContent = match.available ? (submit.getAttribute('data-add-label') || 'Add to cart') : (submit.getAttribute('data-soldout-label') || 'Sold out');
          }
        } else if (submit && isUserChange) {
          // Only set Unavailable on explicit user selection, never on initial page render
          submit.disabled = true;
          submit.textContent = submit.getAttribute('data-unavailable-label') || 'Unavailable';
        }
      };
      picker.addEventListener('change', () => update(true));
      update(false);
    });
  }

  /* ---- Product gallery ------------------------------------------------ */
  let zoomBox;
  function openZoom(src, alt) {
    if (!src) return;
    if (!zoomBox) {
      zoomBox = document.createElement('div');
      zoomBox.className = 'zoom-lightbox';
      zoomBox.innerHTML = '<button type="button" class="zoom-lightbox__close" aria-label="Close">' +
        '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button>' +
        '<img alt="">';
      document.body.appendChild(zoomBox);
      zoomBox.addEventListener('click', () => closeZoom());
      zoomBox.querySelector('img').addEventListener('click', (e) => e.stopPropagation());
    }
    const img = zoomBox.querySelector('img');
    img.src = src; img.alt = alt || '';
    zoomBox.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeZoom() {
    if (zoomBox) { zoomBox.classList.remove('is-open'); document.body.style.overflow = ''; }
  }
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeZoom(); });

  function initGallery(ctx = document) {
    $$('[data-gallery]', ctx).forEach((gal) => {
      const slides = $$('[data-gallery-slide]', gal);
      const showMedia = (id) => {
        slides.forEach((s) => {
          const active = s.getAttribute('data-media-id') === id;
          s.classList.toggle('is-active', active);
          if (!active) { const v = s.querySelector('video'); if (v) v.pause(); const f = s.querySelector('iframe'); if (f) f.src = f.src; }
        });
        $$('[data-gallery-thumb]', gal).forEach((t) => {
          const active = t.getAttribute('data-media-id') === id;
          t.setAttribute('aria-current', active ? 'true' : 'false');
          t.classList.toggle('is-active', active);
        });
      };
      gal._showMedia = showMedia;
      gal.addEventListener('click', (e) => {
        const thumb = e.target.closest('[data-gallery-thumb]');
        if (thumb) { showMedia(thumb.getAttribute('data-media-id')); return; }
        const zoomImg = e.target.closest('[data-zoomable]') || (e.target.closest('[data-zoom-open]') && e.target.closest('.gallery-slide')?.querySelector('[data-zoomable]'));
        if (zoomImg) openZoom(zoomImg.getAttribute('data-zoom-src') || zoomImg.src, zoomImg.alt);
      });
    });
  }

  /* ---- Slideshow ----------------------------------------------------- */
  function initSlideshow(ctx = document) {
    $$('[data-slideshow]', ctx).forEach((root) => {
      const slides = $$('[data-slideshow-slide]', root);
      if (slides.length < 2) return;
      const dots = $$('[data-slideshow-dot]', root);
      const speed = parseInt(root.getAttribute('data-speed'), 10) || 6000;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const autoplay = root.getAttribute('data-autoplay') === 'true' && !reduce;
      let i = 0, timer = null;

      function show(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach((s, idx) => {
          const active = idx === i;
          s.classList.toggle('is-active', active);
          s.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        dots.forEach((d, idx) => {
          d.classList.toggle('is-active', idx === i);
          d.setAttribute('aria-selected', idx === i ? 'true' : 'false');
        });
      }
      function next() { show(i + 1); }
      function prev() { show(i - 1); }
      function start() { if (autoplay) { stop(); timer = setInterval(next, speed); } }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      root.querySelector('[data-slideshow-next]')?.addEventListener('click', () => { next(); start(); });
      root.querySelector('[data-slideshow-prev]')?.addEventListener('click', () => { prev(); start(); });
      dots.forEach((d) => d.addEventListener('click', () => { show(parseInt(d.getAttribute('data-slideshow-dot'), 10)); start(); }));
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      document.addEventListener('visibilitychange', () => { document.hidden ? stop() : start(); });

      show(0); start();
    });
  }

  /* ---- Promo popup --------------------------------------------------- */
  function initPopup() {
    const popup = $('[data-popup]');
    if (!popup) return;
    const days = parseInt(popup.getAttribute('data-popup-days'), 10) || 14;
    const delay = parseInt(popup.getAttribute('data-popup-delay'), 10) || 0;
    const KEY = 'pp_popup_seen';
    let opened = false;
    function open() {
      if (opened) return; opened = true;
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      const f = popup.querySelector('input[type=email]');
      if (f) setTimeout(() => f.focus(), 120);
    }
    function dismiss() {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
    }
    popup.querySelectorAll('[data-popup-close]').forEach((b) => b.addEventListener('click', dismiss));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && popup.classList.contains('is-open')) dismiss(); });
    // Persist dismissal when the email is submitted too.
    popup.querySelector('form')?.addEventListener('submit', () => { try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {} });

    // Auto-open if a submission just happened so the success message shows.
    if (popup.querySelector('.form-success')) { open(); return; }

    const seenAt = parseInt(localStorage.getItem(KEY) || '0', 10);
    if (seenAt && (Date.now() - seenAt) <= days * 86400000) return;

    const timer = setTimeout(open, delay);
    // Exit-intent trigger (desktop): opens early if the cursor leaves the top.
    document.addEventListener('mouseout', (e) => {
      if (!opened && e.clientY <= 0) { clearTimeout(timer); open(); }
    });
  }

  /* ---- Predictive search --------------------------------------------- */
  function initSearch() {
    const drawer = $('#SearchDrawer');
    if (!drawer) return;
    const input = drawer.querySelector('[data-search-input]');
    const results = drawer.querySelector('[data-search-results]');
    if (!input || !results) return;
    let timer;
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(async () => {
        try {
          const url = `${routes.predictive_search_url}?q=${encodeURIComponent(q)}&resources[type]=product,page,article&resources[limit]=6&section_id=predictive-search`;
          const res = await fetch(url);
          const text = await res.text();
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const inner = doc.querySelector('[data-predictive-inner]');
          results.innerHTML = inner ? inner.innerHTML : '';
        } catch (e) {}
      }, 220);
    });
  }

  /* ---- Mobile nav accordions ----------------------------------------- */
  document.addEventListener('click', (e) => {
    const tog = e.target.closest('.mobile-nav__toggle');
    if (!tog) return;
    const sub = tog.nextElementSibling;
    const open = sub.classList.toggle('is-open');
    tog.setAttribute('aria-expanded', open);
  });

  /* ---- Facets / filters (mobile drawer + auto-submit) ---------------- */
  function initFacets() {
    $$('[data-facet-form]').forEach((form) => {
      form.addEventListener('change', () => {
        if (window.matchMedia('(min-width: 990px)').matches) {
          form.requestSubmit ? form.requestSubmit() : form.submit();
        }
      });
    });
    // grid density
    $$('[data-density-btn]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const grid = $('[data-product-grid]');
        if (!grid) return;
        $$('[data-density-btn]').forEach(b => b.setAttribute('aria-pressed', 'false'));
        btn.setAttribute('aria-pressed', 'true');
        grid.setAttribute('data-density', btn.getAttribute('data-density-btn'));
      });
    });
  }

  /* ---- Recently viewed (localStorage) -------------------------------- */
  function recordRecentlyViewed() {
    const meta = $('[data-product-handle]');
    if (!meta) return;
    const handle = meta.getAttribute('data-product-handle');
    let list = [];
    try { list = JSON.parse(localStorage.getItem('pp_recently') || '[]'); } catch (e) {}
    list = [handle, ...list.filter(h => h !== handle)].slice(0, 8);
    localStorage.setItem('pp_recently', JSON.stringify(list));
  }
  async function renderRecentlyViewed() {
    const host = $('[data-recently-viewed]');
    if (!host) return;
    let list = [];
    try { list = JSON.parse(localStorage.getItem('pp_recently') || '[]'); } catch (e) {}
    const current = $('[data-product-handle]')?.getAttribute('data-product-handle');
    list = list.filter(h => h !== current).slice(0, 4);
    if (!list.length) { host.closest('[data-recently-section]')?.setAttribute('hidden', ''); return; }
    const grid = host.querySelector('[data-recently-grid]');
    for (const handle of list) {
      try {
        const res = await fetch(`/products/${handle}?section_id=product-card`);
        const text = await res.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const card = doc.querySelector('[data-product-card]');
        if (card) grid.appendChild(card);
      } catch (e) {}
    }
    if (grid.children.length) host.closest('[data-recently-section]')?.removeAttribute('hidden');
  }

  /* ---- Announcement rotation ----------------------------------------- */
  function initAnnouncement() {
    $$('[data-announcement]').forEach((bar) => {
      const items = $$('.announcement-bar__item', bar);
      if (items.length < 2) return;
      const speed = (parseInt(bar.getAttribute('data-speed'), 10) || 5) * 1000;
      let i = 0;
      setInterval(() => {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, speed);
    });
  }

  /* ---- Sticky add-to-cart visibility --------------------------------- */
  function initStickyAtc() {
    const sticky = $('[data-sticky-atc]');
    const anchor = $('[data-atc-anchor]');
    if (!sticky || !anchor || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver(([entry]) => {
      sticky.style.transform = entry.isIntersecting ? 'translateY(100%)' : 'none';
    });
    io.observe(anchor);
  }

  /* ---- Inline product embeds (Shop this guide in articles) ----------- */
  function initProductEmbeds(ctx) {
    (ctx || document).querySelectorAll('[data-product-embed]:not([data-embed-done])').forEach((node) => {
      const handle = node.getAttribute('data-product-embed');
      if (!handle) return;
      node.setAttribute('data-embed-done', '1');
      fetch('/products/' + handle + '.js')
        .then((r) => (r.ok ? r.json() : null))
        .then((p) => {
          if (!p) return;
          let img = p.featured_image || '';
          if (img.indexOf('//') === 0) img = 'https:' + img;
          const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD';
          let price;
          try { price = (p.price / 100).toLocaleString(undefined, { style: 'currency', currency: cur }); }
          catch (e) { price = '$' + (p.price / 100).toFixed(2); }
          const a = document.createElement('a');
          a.className = 'product-embed';
          a.href = '/products/' + p.handle;
          a.innerHTML =
            '<span class="product-embed__media">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</span>' +
            '<span class="product-embed__body"><span class="product-embed__label">Shop this guide</span>' +
            '<span class="product-embed__title">' + p.title + '</span>' +
            '<span class="product-embed__price">' + price + '</span></span>' +
            '<span class="product-embed__cta">View &rarr;</span>';
          node.replaceWith(a);
        })
        .catch(() => {});
    });
  }

  /* ---- Init ----------------------------------------------------------- */
  function init() {
    initVariantPickers();
    initGallery();
    initSearch();
    initFacets();
    initAnnouncement();
    initStickyAtc();
    initProductEmbeds();
    cartExtras();
    recordRecentlyViewed();
    renderRecentlyViewed();
    initPopup();
    initSlideshow();
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  // Re-init on Shopify theme editor section load
  document.addEventListener('shopify:section:load', init);
})();
